import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/plugins/naver/shopping";

export const shopping = {
    // ...example,
    products(data){
        return axios.get(`${url}/products`, data).then(result => result.data);
    },
}
